import { useNavigate } from 'react-router-dom';
import { Screen } from '../../app/Frame';
import { useScreen } from '../../app/shell-context';
import { formatKop } from '../../lib/money';
import { pluralWithCount } from '../../lib/plural';
import { Opt } from '../../ui/parts';
import { useDirections, useIntakeByDirection } from '../api';
import { UNSURE, useOnboarding } from '../OnboardingContext';

/**
 * Первый вход, шаг 3: направление. В списке остаются только те, где есть
 * первичный приём и кто-то его ведёт, — иначе выбор упирается в пустоту.
 * Вариант «пока не знаю» есть всегда: он ведёт к заявке администратору.
 */
export function DirectionStep() {
  const navigate = useNavigate();
  const { nb, patch } = useOnboarding();
  const directions = useDirections();
  const ids = (directions.data ?? []).map((d) => d.id);
  const intake = useIntakeByDirection(ids);

  useScreen('Категория', {
    label: 'Далее',
    disabled: nb.directionId === null,
    onClick: () => navigate('/onboarding/result'),
  });

  const available = (directions.data ?? []).filter((d) => {
    const i = intake.byId.get(d.id);
    return i?.service && i.specialists.length > 0;
  });

  return (
    <Screen>
      <div>
        <p className="eyebrow">Шаг 3 из 3</p>
        <p className="lead" style={{ marginTop: 6 }}>
          К какому специалисту записаться? Если не уверены — так и отметьте, администратор подскажет.
        </p>
      </div>

      {directions.isPending || intake.isPending ? <p className="lead">Смотрим, к кому можно попасть…</p> : null}

      <div className="options">
        {available.map((d) => {
          const i = intake.byId.get(d.id)!;
          return (
            <Opt
              key={d.id}
              pressed={nb.directionId === d.id}
              title={d.title}
              aside={<span>{formatKop(i.specialists[0].priceKop)}</span>}
              note={`${i.service!.title} · ${i.service!.durationMin} мин · принимают ${pluralWithCount(i.specialists.length, 'специалист', 'специалиста', 'специалистов')}`}
              onClick={() => patch({ directionId: d.id, specialistId: null })}
            />
          );
        })}

        <Opt
          pressed={nb.directionId === UNSURE}
          title="Пока не знаю"
          note="Опишем ситуацию администратору — он предложит, с чего начать."
          onClick={() => patch({ directionId: UNSURE, specialistId: null })}
        />
      </div>

      {!intake.isPending && available.length === 0 ? (
        <p className="footnote">
          Первая запись сейчас не открыта ни в одной категории — выберите «Пока не знаю»,
          администратор подберёт специалиста и время.
        </p>
      ) : null}
    </Screen>
  );
}
